/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-lonely-if */
/* eslint-disable no-plusplus */
/* eslint-disable func-names */
import EDC from './globals';

/**
 *
 */
EDC.Languages = function (scene) {
  this.scene = scene;
  this.prefix = 'language-';
  this.data = null;
};
/**
 *
 */
EDC.Languages.prototype.setLanguage = function (langCode) {
  this.data = this.scene.cache.json.get(this.prefix + langCode).data;
};
/**
 *
 */
EDC.Languages.prototype.getString = function (id) {
  if (!this.data) {
    console.warn('No language data');
    return id;
  }

  const arr = id.split('.');
  let value = null;
  let root = this.data;
  for (let i = 0; i < arr.length; i++) {
    const subId = arr[i];
    if (root.hasOwnProperty(subId)) {
      value = root[subId];
      if (typeof value !== 'string') {
        value = null;
        root = root[subId];
      } else {
        if (i < (arr.length - 1)) {
          value = null;
        }
      }
    } else {
      value = null;
      break;
    }
  }

  return value ? value : id;
};

export default EDC.Languages;
